import React from 'react';

import { styles } from './styles';

export const GuestLayout: React.FC = ({ children }) => <div style={styles.container}>{children}</div>;
